import ScrapSavvyHome from "./ScrapSavvyHome";

function App() {
  return <ScrapSavvyHome />;
}

export default App;
